const part = [
    // {
    //     path: 'package-management-list',
    //     name: 'package-management-list',
    //     meta: {
    //         icon: 'md-people',
    //         title: '纸箱费',
    //         notCache: true,
    //         access: ['S'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/system-management/package-management/package-list')
    // }
];

export default part;
